import { useTranslation } from "react-i18next";
import { FALLBACK_LOCALE } from "@/engine/state/locale";

/**
 * The locale the interface is being rendered in.
 *
 * It reads the i18next instance rather than the store, because the instance is
 * the one answer both sides of the seam agree on: on the server it is the
 * per-request instance the request resolved, on the client the singleton the
 * store moves. Reading the store here would give the server no answer it could
 * honestly give — that is what #310 was — and a control rendered in one
 * language inside a page rendered in another.
 *
 * `useTranslation` also subscribes the caller to `languageChanged`, so a
 * control showing the current language re-renders when it changes.
 */
export function useLocale(): string {
  const { i18n } = useTranslation();
  return i18n.resolvedLanguage ?? i18n.language ?? FALLBACK_LOCALE;
}
